import { gsap, TimelineMax, Power2, Power4, CSSRulePlugin, ScrollTrigger, MorphSVGPlugin } from 'gsap/all';
require("../__vendor/SplitText.min.js");

gsap.registerPlugin(CSSRulePlugin, ScrollTrigger); 

const loader = () => {
    let loaderTl = gsap.timeline();
    
    loaderTl.set(".loader", {
        className: "+=loader loader--show"
    }).set(".loader", {
        className: "+=loader loader--show loader--hide"
    }, 2).set(".circle", {
        className: "+=circle circle-show"
    }, 2.25).to(".slider--item-first img", 0.7, {
        y: 0,
        autoAlpha: 1,
        scale: 1,
        ease: Power4.ease
    }, 2.825).set(".loader", {
        display: "none"
    }).to(".slider h2", 0.9, {
        autoAlpha: 1,
        y: "-50%",
        scaleX: 1,
        scaleY: 1,
        ease: Power4.ease
    }, 2.95).to(".logo img", 0.75, {
        autoAlpha: 1
    }, 3.6).set(".slider", {
        className: "+=slider slider-loaded"
    }).to(".menubar", 1, {
        autoAlpha: 1
    }, 3.65).staggerTo(".menu li", 0.5, {
        autoAlpha: 1
    }, 0.015, 3.65).to(".btn", 0.5, {
        scale: 1,
        autoAlpha: 1
    }, 3.3).staggerTo(".social-media li", 1, {
        autoAlpha: 1
    }, 0.1, 3.85);
};

export default loader;